export default __webpack_public_path__ + "static/media/minds.0ff33d22.png";